import React, { useState, useEffect } from 'react';
import { API_URL } from '../config';

function TrendingPrompts({ onSelectPrompt }) {
  const [prompts, setPrompts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function fetchTrending() {
      try {
        const res = await fetch(`${API_URL}/trending-prompts`);
        const data = await res.json();
        if (!cancelled && data.prompts && data.prompts.length > 0) {
          setPrompts(data.prompts);
        }
      } catch {
        // silently fail — not critical
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    fetchTrending();
    return () => { cancelled = true; };
  }, []);

  // Don't render anything while loading or if no data
  if (loading || prompts.length === 0) return null;

  return (
    <div className="trending-prompts">
      <span className="trending-label">🔥 Trending</span>
      <div className="trending-chips">
        {prompts.map((item, i) => (
          <button
            key={i}
            className="trending-chip"
            onClick={() => onSelectPrompt && onSelectPrompt(item.prompt)}
            title={`Used ${item.count} time${item.count !== 1 ? 's' : ''}`}
          >
            <span className="trending-chip-text">{item.prompt.length > 40 ? item.prompt.slice(0, 38) + '…' : item.prompt}</span>
            {item.count > 1 && (
              <span className="trending-chip-count">×{item.count}</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

export default TrendingPrompts;
